import { useEffect, useState, type ReactNode } from 'react';
import classNames from 'classnames';

import useStyles from './styles';

interface HomeToolLayerProps {
  isActive: boolean;
  children: ReactNode;
}

/**
 * One home-tool panel layer. Mounts its children on first activation and then
 * keeps them mounted, hidden via `visibility` — so a tool's content and state
 * survive tab switches, and it never mounts (or runs its effects) for users who
 * never open it. Generic: knows nothing about any specific tool.
 */
const HomeToolLayer = ({ isActive, children }: HomeToolLayerProps) => {
  const classes = useStyles();
  const [hasActivated, setHasActivated] = useState(false);

  useEffect(() => {
    if (isActive) setHasActivated(true);
  }, [isActive]);

  if (!isActive && !hasActivated) return null;

  return (
    <div
      className={classNames(classes.layer, { [classes.hidden]: !isActive })}
      aria-hidden={!isActive}
    >
      {children}
    </div>
  );
};

export default HomeToolLayer;
